// src/firebase.js
// import firebase from "firebase/app";
// import "firebase/firestore";
// import "firebase/auth";
import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import "firebase/compat/firestore";
import { doc, getDoc, getFirestore, setDoc } from "firebase/firestore";
import { getMessaging } from "firebase/messaging";

// tutify gmail account
const firebaseConfig = {
  apiKey: "AIzaSyAwV2sP0NFZG3E4KrZaavGXpeWuPXT1bf0",
  authDomain: "tutify-online.firebaseapp.com",
  projectId: "tutify-online",
  storageBucket: "tutify-online.appspot.com",
  messagingSenderId: "912640961954",
  appId: "1:912640961954:web:6e892482ca5a4990aa16fb",
  measurementId: "G-7V82WQMWDG",
};

// huzaifa gmail account

// const firebaseConfig = {
//   apiKey: "AIzaSyDuyKyCOZqgoXJdmooSxI3bOJG0B3fHkqU",
//   authDomain: "chat-app-b9274.firebaseapp.com",
//   projectId: "chat-app-b9274",
//   storageBucket: "chat-app-b9274.appspot.com",
//   messagingSenderId: "867378865647",
//   appId: "1:867378865647:web:08a35720c0ac335d9f421a",
//   measurementId: "G-T6JJ6RLMJY",
// };

const app = firebase.initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const messaging = getMessaging(app);
export const auth = firebase.auth();
export const firestore = firebase.firestore();

export default firebase;
